<!--
 * @FileDescription: 联合办学情况展板
 * @Author: 作者信息
 * @Date: 文件创建时间
 * @LastEditors: dcq
 * @LastEditTime: 2023-07-26 12:43:34
 -->
<template>
    <div class="student-tab">
        <KeyValTemplate order="0" title="联合办学学校情况" :nameValList="nameValListA" keyValId="2" />
        <ChartTemplate v-for="chart in chartsInfo" :key="chart.chartId" :chartId="chart.chartId" :order="chart.order"
            :styleType="chart.styleType" />
        <PicCarousel order="4" :schoolIndex="currentSchoolIndex" keyId="2" />
        <DescribeTemplate order="5" :schoolIndex="currentSchoolIndex" keyValId="2" />
    </div>
    <MapTemplate order="3" @click-school="ChangeSchool" />
    <div class="column-background"></div>
</template>

<script>
export default {
    name: 'StudentTab',
    // mounted() {
    //     // this.getUnionList();
    //     this.spliceUnionSchool();
    // },
    // methods: {
    //     //拼接
    //     spliceUnionSchool() {
    //         // var schoolPtAll = activeJson.unionSchoolPt.features;
    //         var schoolPtAll = this.schoolPtAll;
    //         console.log("schoolPtAll",schoolPtAll);
    //         //临时数组 
    //         var tempMiddleList = [];  //中学
    //         var tempprimaryList = []; //小学
    //         var tempGardenList = [];  //幼儿园
    //         for (let index = 0; index < schoolPtAll.length; index++) {
    //             if (schoolPtAll[index].properties.type == "中学") {
    //                 tempMiddleList.push(schoolPtAll[index]);
    //                 // this.nameValListA[0].val = this.middleSchoolData.length + '所'
    //             } else if (schoolPtAll[index].properties.type == "小学") {
    //                 tempprimaryList.push(schoolPtAll[index])
    //             } else if (schoolPtAll[index].properties.type == "幼儿园") {
    //                 tempGardenList.push(schoolPtAll[index]);
    //             }
    //         }
    //         // for (let item in schoolPtAll) {
    //         //     // console.log("遍历json",item);
    //         //     if (item.properties.type == "中学") {
    //         //         tempMiddleList.push(item);
    //         //         // this.nameValListA[0].val = this.middleSchoolData.length + '所'
    //         //     } else if (item.properties.type == "小学") {
    //         //         tempprimaryList.push(item)
    //         //     } else if (item.properties.type == "幼儿园") {
    //         //         tempGardenList.push(item);
    //         //     }
    //         // }
    //         this.nameValListA[0].val = tempMiddleList.length + '所'
    //         this.nameValListA[1].val = tempprimaryList.length + '所'
    //         this.nameValListA[2].val = tempGardenList.length + '所'


    //         // requestApi.getUnionList().then((res) => {
    //         //     this.unionData = res.data.data[0];
    //         //     console.log("联合信息列表", this.unionData);
    //         //     for (let i = 0; i < this.unionData.length; i++) {
    //         //         if (this.unionData[i].schoolType == "中学") {
    //         //             this.middleSchoolData.push(this.unionData[i])
    //         //         } else if (this.unionData[i].schoolType == "小学") {
    //         //             this.primarySchoolData.push(this.unionData[i])
    //         //         } else if (this.unionData[i].schoolType == "幼儿园") {
    //         //             this.kindergartenData.push(this.unionData[i])
    //         //         }
    //         //         // console.log("分解后：",this.unionData[i]);
    //         //     }
    //         //     console.log("middleSchoolData", this.middleSchoolData);
    //         //     console.log("primarySchoolData", this.primarySchoolData);
    //         //     console.log("kindergartenData", this.kindergartenData);

    //         //     this.nameValListA[0].val = this.middleSchoolData.length + '所'
    //         //     this.nameValListA[1].val = this.primarySchoolData.length + '所'
    //         //     this.nameValListA[2].val = this.kindergartenData.length + '所'


    //         // })
    //     },
    // },
    // data() {
    //     return {
    //         unionData: [],

    //         //中学
    //         middleSchoolData: [],

    //         //小学
    //         primarySchoolData: [],

    //         //幼儿园
    //         kindergartenData: [],

    //         nameValListA: [
    //             { name: '中学', val: '' },
    //             { name: '小学', val: '' },
    //             { name: '幼儿园', val: '' },
    //             { name: '覆盖区县', val: '18个' },
    //         ]
    //     }
    // },

}
</script>

<script setup>
import { ref, onMounted } from 'vue';
// import requestApi from '@/api/requestApi';
import ChartTemplate from './tabTemplates/ChartTemplate.vue';
import KeyValTemplate from './tabTemplates/KeyValTemplate.vue';
// import ArcLayerTemplate from './tabTemplates/ArcLayerTemplate.vue';
import MapTemplate from './tabTemplates/MapTemplate.vue';
import PicCarousel from './tabTemplates/PicCarousel.vue';
import DescribeTemplate from './tabTemplates/DescribeTemplate.vue'
// import activeJson from "@/components/activeChartData.json"
import axios from 'axios';

const chartsInfo = [
    { "chartId": '4', "order": '1', "styleType": '5' },
    { "chartId": '5', "order": '2', "styleType": '6' },
]

// const nameValListA = [
//     { name: '中学', val: '19所' },
//     { name: '小学', val: '12所' },
//     { name: '幼儿园', val: '4所' },
//     { name: '覆盖区县', val: '18个' },
// ]

let currentSchoolIndex = ref(0);

let activeJson = ref({})
let schoolPtAll = ref([])

// let unionData = []

// //中学
// let middleSchoolData = []

// //小学
// let primarySchoolData = []

// //幼儿园
// let kindergartenData = []

let nameValListA = ref([
    { name: '中学', val: '' },
    { name: '小学', val: '' },
    { name: '幼儿园', val: '' },
    { name: '覆盖区县', val: '18个' },
])

onMounted(() => {
    //   console.log(`the component is now mounted.`)
    axios.get('/activeChartData.json')
        .then(response => {
            activeJson.value = response.data;
            schoolPtAll.value = activeJson.value.unionSchoolPt.features

            var tempMiddleList = [];  //中学
            var tempprimaryList = []; //小学
            var tempGardenList = [];  //幼儿园
            for (let index = 0; index < schoolPtAll.value.length; index++) {
                if (schoolPtAll.value[index].properties.type == "中学") {
                    tempMiddleList.push(schoolPtAll.value[index]);
                    // this.nameValListA[0].val = this.middleSchoolData.length + '所'
                } else if (schoolPtAll.value[index].properties.type == "小学") {
                    tempprimaryList.push(schoolPtAll.value[index])
                } else if (schoolPtAll.value[index].properties.type == "幼儿园") {
                    tempGardenList.push(schoolPtAll.value[index]);
                }
            }
            // this.nameValListA[0].val = tempMiddleList.length + '所'
            // this.nameValListA[1].val = tempprimaryList.length + '所'
            // this.nameValListA[2].val = tempGardenList.length + '所'
            nameValListA.value[0] = { name: '中学', val: tempMiddleList.length + '所' }
            nameValListA.value[1] = { name: '小学', val: tempprimaryList.length + '所' }
            nameValListA.value[2] = { name: '幼儿园', val: tempGardenList.length + '所' }
        })
        .catch(error => {
            console.log(error);
        });
})

const ChangeSchool = (schoolIndex) => {
    currentSchoolIndex.value = schoolIndex;
    console.log('change school', schoolIndex);
}

</script>


<style lang="scss" scoped>
div.student-tab {
    position: absolute;
    width: 100vw;
    height: 84vh;
    display: flex;
    flex-flow: column wrap;
    justify-content: space-between;
    column-gap: 48vw;
    overflow: hidden;
    // background-color: red;
}

div.column-background {
    position: absolute;
    left: 1vw;
    top: 0.5vh;
    width: 20vw;
    height: 82vh;
    border-radius: 5px;
    margin-top: 0.5vh;
    // margin-bottom: 1vh;
    background-color: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(2px);
    z-index: 11;
}
</style>